import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { LucideAngularModule } from 'lucide-angular';
import { PackLimitationsService } from '../../services/pack-limitations.service';

@Component({
  selector: 'app-discovery-progress',
  standalone: true,
  imports: [
    CommonModule,
    ProgressBarModule,
    TagModule,
    TooltipModule,
    TranslocoModule,
    LucideAngularModule,
  ],
  templateUrl: './discovery-progress.component.html',
  styleUrls: ['./discovery-progress.component.scss'],
})
export class DiscoveryProgressComponent {
  protected packLimitationService = inject(PackLimitationsService);
  tripUsed: number = 0;
  tripLimit: number = 0;

  constructor() {
    effect(() => {
      this.tripUsed = this.packLimitationService.currentNumberOfTrips();
      this.tripLimit = this.packLimitationService.tripLimit();
    });
  }

  /**
   * Récupère le pourcentage d'utilisation
   */
  get progressPercentage(): number {
    if (this.tripLimit === 0) return 0;
    return Math.round((this.tripUsed / this.tripLimit) * 100);
  }

  /**
   * Récupère la couleur de la progress bar selon l'avancement
   */
  get progressColor(): string {
    return 'rgb(188 211 202)'; // primary-200 from Tailwind config
  }

  /**
   * Récupère le message du tooltip
   */
  get tooltipMessage(): string {
    return `Vous êtes en mode découverte. Créez jusqu'à ${this.tripLimit} trip(s) gratuitement, puis contactez-nous pour continuer.`;
  }

  /**
   * Vérifie si la limite est atteinte
   */
  get isLimitReached(): boolean {
    return this.tripUsed >= this.tripLimit;
  }

  /**
   * Ouvre la modale de contact
   */
  openContactModal(): void {
    this.packLimitationService.openModal();
  }
}
